import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useAgentsAssistance(): RootState['agentsAssistance'] {
    const agentsAssistance = useSelector<RootState, RootState['agentsAssistance']>(
        ({ agentsAssistance }) => agentsAssistance,
    )
    return agentsAssistance
}
